import AdminPredefinedInterview from '@components/AdminPredefinedInterview/AdminPredefinedInterview.component'
import { Box, Button, styled, TextareaAutosize, Typography } from '@mui/material'
import { useMutation, useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import axios from 'axios'
import NoData from 'icons/NoData.icon'
import { useState } from 'react'

export const Route = createFileRoute(
  '/(partner)/_partner/interview-generator-step1',
)({
  component: RouteComponent,
})


const StyledContainer = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '48px 56px',
    background: '#ffffff',
    borderRadius: '24px',
    boxShadow: '0px 1px 2px 0px #0205111A',
    width: '100%',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
        padding: '24px',
    },
}))

const StyledTextArea = styled(TextareaAutosize)(() => ({
  width: '100%',
  minHeight: '200px',
  padding: '12px',
  borderRadius: '8px',
  border: '1px solid var(--Interviewer-Lightest-Black)',
  fontFamily: 'inherit',
  fontSize: '14px',
  lineHeight: '20px',
  resize: 'vertical',
  '&:focus': {
    outline: 'none',
  },
}))

function RouteComponent() {
    const search = useSearch({ from: '/(partner)/_partner/interview-generator-step1' }) as {
        techId?: string;
        // category?: string;
    };

    const techId = search?.techId;
    const navigate = useNavigate();
    // const category = search?.category;

    //Novo
    const [description, setDescription] = useState('');

    const { data: interviews, isLoading, error} = useQuery({
        queryKey: ['interviews'],
        queryFn: async () => {
            const token = localStorage.getItem('token');
            const results = await axios.get(`https://interviewer.runasp.net/api/interviews/main?technologyId=${techId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            return results
        }
    })


    const mutation = useMutation({
        mutationFn: async (data :{jobDescription: string}) => {
            const token = localStorage.getItem('token');
            const response = await axios.post(`https://interviewer.runasp.net/api/technologies/${techId}/categories/scale`,
            {
                "jobDescription" : data.jobDescription
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            return response.data
        },
        onSuccess: (data) => {
            navigate({
                to: '/interview-genarator-step2',
                state: { 
                    categories: data,
                    techId: techId
                }
            })
        },
        onError: (error) => {
            console.error('Error creating user:', error)
        },
    })

    const handleClick = () => {
        mutation.mutate({jobDescription: description})
    }

    return (
        <Box>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '12px', mx: 'auto', maxWidth: {xs: '100%', md: '80%'}, textAlign: 'center', pb: '32px'}}>
                <Typography variant="h1">
                    Tell us about the job position you are creating interview for
                </Typography>
                <Typography sx={{fontSize: '16px'}}>
                    It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.
                </Typography>
            </Box>

            <StyledContainer>
                <Typography variant="h3" sx={{ pb: '8px', fontSize: '16px' }}>
                    Job description
                </Typography>
                <StyledTextArea 
                    value={description} 
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Describe the job you're creating an interview for..." 
                />
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: '32px' }}
                    onClick={() => handleClick()}
                    disabled={mutation.isPending}
                >
                    Next
                </Button>
            </StyledContainer>

            <Box sx={{ py: '56px', width: '100%', px: {xs:'0px', md:'56px'} }}>
                <Typography variant="h4" sx={{ pb: '12px', fontWeight: '600', color: 'var(--Interviewer-Lightest-Black)' }}>In a rush? We got you</Typography>
                <Typography variant="h2" sx={{ pb: '32px' }}>Try our predefined job interviews</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {isLoading && <Typography>Loading</Typography>}
                    {error && <NoData />}
                    {interviews &&
                        interviews.data?.map((interview) => (
                            <AdminPredefinedInterview 
                                key={interview.id}
                                interview={interview}
                            />
                        ))
                    }
                </Box>
            </Box>
        </Box>
    )
}
